export default __webpack_public_path__ + "static/foundstages-ro-d94d6174d0d49f893e8f72b05c0d2087.png";